import ResumeItem from "@/common/components/ResumeItem";
import { useFormContext, useWatch } from "react-hook-form";
import { DirectiveDiagnosticValidationSchema } from "../../../../schemas/maintenanceForwardingDirectiveSteps.schema";
import { MaintenanceForwardingsDirectiveFormStepProps } from "../../../../types/maintenanceforwardingsDirectiveFormStep.type";
import { MaintenanceForwardingsDirectiveFromSteps } from "../../../../types/maintenanceForwardingsShowDirectiveDetails.type";
import CreateForwardingDirectiveEntryFormStepCompleted from "../../../CreateForwardingDirectiveEntryFormStepCompleted";

const DirectiveDiagnosticFormStepCompleted = ({
  stepIndex,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.DirectiveDiagnostic>) => {
  const {
    control,
  } = useFormContext<DirectiveDiagnosticValidationSchema>();

  const {
    diagnostic: watchDiagnostic,
  } = useWatch({
    control,
  });

  return (
    <CreateForwardingDirectiveEntryFormStepCompleted
      stepIndex={stepIndex}
      title="Prosseguir com Diagnóstico e Orçamento"
      body={(
        <div>
          <ResumeItem
            label="Diagnóstico e orçamento selecionado"
            value={(watchDiagnostic?.label as string | JSX.Element) || '--'}
            className="text-sm"
          />
        </div>
      )}
    />
  )
}

export default DirectiveDiagnosticFormStepCompleted;
